/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Meeting_Sources_Document_SizeInputs */



/**
* | output |
* | --- |
* | "That file is too big. {size} at most." |
*
* @param {Meeting_Sources_Document_SizeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_size = /** @type {((inputs: Meeting_Sources_Document_SizeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_SizeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Dat bestand is te groot. Maximaal ${i?.size}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce fichier est trop volumineux. ${i?.size} au maximum.`)
	return /** @type {LocalizedString} */ (`That file is too big. ${i?.size} at most.`)
});